export default {
  supportEmail: 'success@unyte.com',
}
